import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as AlertTriangle } from "src/assets/static/images/alert-triangle.svg";
import actions from "src/store/profileMain/actions";

function UpdatesContainer() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.getTechnicalMessages());
    }, [])

    const teqnicalMessages = useSelector(state => state.profileMain.teqnicalMessages);

    return (
        <>
            {Boolean(teqnicalMessages?.data) &&
                <>
                    <div className="updates-container container mt-5 p-4">
                        <div className="row">
                            <div className="col-1 d-flex align-items-center">
                                <AlertTriangle />
                            </div>
                            <div className="col-11 my-auto">
                                {teqnicalMessages?.data?.displayNameNat} <br /> <br />
                                {teqnicalMessages?.data?.displayNameLat}
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    )
}

export default UpdatesContainer;